<template>
  <div class="col-md-6 col-sm-12 pl-0">
    <card :class="'card-catalog-' + theme">
      <p class="text-center font-weight-bold h5">
        Análise Top Trader
      </p>
      <div class="row">
        <div class="col-3">
          <strong style="font-size: 18px"> Vela: </strong>
          <span
            style="cursor: auto; padding: 22px"
            :class="
              'btn btn-round btn-icon btn-fill btn-' + candleAndTimeOrders.color
            "
          >
          </span>
        </div>
        <div class="col-3">
          Próxima Entrada
          <span
            style="cursor: auto"
            class="btn btn-round btn-neutral text-dark"
          >
            <strong style="color: #083854; font-size: 18px">
              {{ candleAndTimeOrders.nextOrder.hour }}
            </strong>
            <span class="mb-0"> {{ candleAndTimeOrders.nextOrder.date }} </span>
          </span>
        </div>
        <div class="col-3">
          <p class="mb-0">1º Martingale</p>
          <span
            style="cursor: auto"
            class="btn btn-round btn-neutral text-dark"
          >
            <strong style="color: #083854; font-size: 18px">
              {{ candleAndTimeOrders.firstMartingale.hour }}
            </strong>
            <span class="mb-0">
              {{ candleAndTimeOrders.firstMartingale.date }}</span
            >
          </span>
        </div>
        <div class="col-3">
          <p class="mb-0">2º Martingale</p>
          <span
            style="cursor: auto"
            class="btn btn-round btn-neutral text-dark"
          >
            <strong style="color: #083854; font-size: 18px">
              {{ candleAndTimeOrders.secondMartingale.hour }}
            </strong>
            <span class="mb-0">
              {{ candleAndTimeOrders.secondMartingale.date }}</span
            >
          </span>
        </div>
      </div>
      <hr />
      <div>
        <p class="text-center font-weight-bold h6">
          Histórico
        </p>
        <div class="row">
          <ul id="cycles" class="card-body col-lg-12 col-md-12 col-sm-12">
            <li v-for="(analisysResult, index) in historyAnalises" :key="index">
              <button
                type="button"
                :title="'Fechamento: ' + analisysResult.timeOnHover"
                :class="
                  'btn btn-sm btn-' +
                    (analisysResult.type === 'win' ? 'success' : 'danger')
                "
              >
                <samp>{{ analisysResult.time }}</samp>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  props: {
    candleAndTimeOrders: {
      color: String,
      nextOrder: {
        hour: String,
        date: String
      },
      firstMartingale: {
        hour: String,
        date: String
      },
      secondMartingale: {
        hour: String,
        date: String
      }
    },
    historyAnalises: Array
  },
  data() {
    return {
      key: "value"
    };
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/SignalsCard.vue